export const reportingObjectsTypesMap = {
    passway: 'Passways',
    zone: 'Zones',
    place: 'Places',
    floor: 'Floors',
    location: 'Location',
    tenant: 'Tenants',
};
